import CitiesAPI from '@/services/api/landing/api-cities';

export default {
  namespaced: true,

  state: () => ({
    items: null
  }),

  getters: {
    items: state => state.items
  },

  mutations: {
    set(state, items) {
      state.items = items;
    }
  },

  actions: {
    async list({ state, commit }) {
      try {
        if (state.items) return state.items;
        let res = await CitiesAPI.list();
        commit('set', res);
        return res;
      } catch (error) {
        console.log(error);
        return Promise.reject(error);
      }
    },
  }
};